module.exports = __webpack_public_path__ + "img/app-pornhub.6eb1d0c3.webp";